import { Award, Heart, Truck, Users } from "lucide-react";

const ABOUT_IMG = "https://customer-assets-agu9un31.emergentagent.net/job_cat-cage-shop/artifacts/aamtpp3b_IMG_1930.jpeg";

const About = () => {
  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-14 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="label-eyebrow text-[#E07A5F]">Tentang Kami</div>
            <h1 className="font-heading font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tight text-[#1C1C1C] mt-4 leading-[1.02] text-balance">
              Kerana setiap kucing layak rumah yang selesa.
            </h1>
            <p className="text-base lg:text-lg text-[#4A4A4A] mt-6 leading-relaxed max-w-xl">
              Sangkar Murah Enterprise bermula pada 2018 sebagai sebuah perniagaan keluarga
              kecil di Puchong, Selangor. Kami sendiri adalah pemilik kucing yang memahami
              betapa pentingnya rumah yang selesa untuk peliharaan kita.
            </p>
            <p className="text-base text-[#4A4A4A] mt-4 leading-relaxed max-w-xl">
              Hari ini, kami telah berkembang menjadi salah satu pembekal sangkar kucing
              terkemuka di Malaysia dengan lebih 2,400 pelanggan setia dari Perlis ke Sabah.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="aspect-square rounded-[2.5rem] overflow-hidden bg-[#F4F1EA]">
              <img src={ABOUT_IMG} alt="Kucing comel" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#F4F1EA] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <div className="label-eyebrow text-[#E07A5F]">Nilai Kami</div>
            <h2 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-[#1C1C1C] mt-3 text-balance">
              Apa yang kami percaya.
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Heart, title: "Sayang Haiwan", desc: "Setiap keputusan dibuat dengan haiwan sebagai keutamaan." },
              { icon: Award, title: "Kualiti Premium", desc: "Hanya bahan terbaik dipilih untuk setiap sangkar." },
              { icon: Truck, title: "Penghantaran Pantas", desc: "Penghantaran lori kedai ke seluruh Malaysia." },
              { icon: Users, title: "Komuniti Terbuka", desc: "Sokongan WhatsApp & grup pemilik kucing." },
            ].map((v, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 border border-[rgba(28,28,28,0.06)]">
                <div className="w-11 h-11 rounded-xl bg-[#E07A5F]/10 flex items-center justify-center">
                  <v.icon className="w-5 h-5 text-[#E07A5F]" />
                </div>
                <h3 className="font-heading font-semibold text-xl text-[#1C1C1C] mt-5">{v.title}</h3>
                <p className="text-sm text-[#4A4A4A] mt-2 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {[
            { v: "2,400+", l: "Pelanggan setia" },
            { v: "7+", l: "Tahun pengalaman" },
            { v: "30+", l: "Model sangkar" },
            { v: "4.9★", l: "Rating purata" },
          ].map((s, i) => (
            <div key={i}>
              <div className="font-heading font-bold text-5xl sm:text-6xl tracking-tight text-[#E07A5F]">{s.v}</div>
              <div className="text-sm text-[#4A4A4A] mt-3">{s.l}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
